import React, { useState } from "react";
import { Button } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { BUTTON_STYLES } from "../../styles/componentStyles";
import BulkImportDialog from "./BulkImportDialog";

// Self-contained "Import" button + dialog, dropped next to each screen's "Add" button.
// Styled exactly like the Add button so the two sit together as a matching pair.
export default function BulkImportButton({ onImported }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        startIcon={<UploadFileIcon />}
        onClick={() => setOpen(true)}
        {...BUTTON_STYLES.primary}
        sx={{ minWidth: { xs: "120px", md: "auto" }, fontSize: { xs: "10px", md: "12px" } }}
      >
        Import
      </Button>
      <BulkImportDialog open={open} onClose={() => setOpen(false)} onImported={onImported} />
    </>
  );
}
